/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: lixiaoqi04
 * @LastEditTime: 2023-09-06 14:39:37
 * @FilePath: /wblog/src/action/addJS.ts
 * @Description:
 */
// 动态添加JS

export function loadJS(url: string, success?: Function) {
    const domScript = document.createElement('script');
    const versions: string = new Date().getTime().toString();
    domScript.type = 'text/javascript';
    domScript.async = true;
    domScript.src = url.indexOf('?') > -1 ? `${url}&_v=${versions}` : `${url}?_v=${versions}`;
    success = success || function () {};
    function cleanup() {
        if (domScript.parentNode) {
            domScript.parentNode.removeChild(domScript);
        }
    }
    domScript.onload = function () {
        success && success();
    };

    domScript.onerror = function (e) {
        console.error(`【zp-weblog】加载脚本异常: ${url}`, e);
        cleanup();
    };
    document.head.appendChild(domScript);
}
